import React from "react"
import { Redirect } from "react-router-dom"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ResetPwd from "../pages/Authentication/ResetPassword"
import VerifyingEmail from "../pages/Authentication/VerifyingEmail";
import UserProfile from "../pages/Authentication/user-profile";
import Beneficiaries from "../pages/Dashboard/Beneficiaries";
import WireTransfer from "../pages/Dashboard/wireTransfer";
import InterbankTransfer from "../pages/Dashboard/interbankTransfer";
import PayPalTransfer from "../pages/Dashboard/paypal";
import SkrillTransfer from "../pages/Dashboard/skrill";
import GPay from "../pages/Dashboard/googlePay";
import Payoneer from "../pages/Dashboard/payoneer";
import Wise from "../pages/Dashboard/transferWise";
import LoanAdmin from "../pages/Dashboard/LoanAdmin";
import LoanApply from "../pages/Dashboard/LoanApply";
import LoanHistory from "../pages/Dashboard/LoanHistory";
import FDRAdmin from "../pages/Dashboard/FDRAdmin";
import FDRApply from "../pages/Dashboard/FDRApply";
import FDRHistory from "../pages/Dashboard/FDRHistory";
import TransactionHistory from "../pages/Dashboard/TransactionHistory";
import ManageUsers from "../pages/Dashboard/ManageUsers";
import ManageFDR from "../pages/Dashboard/ManageFDR";
import ManageLoans from "../pages/Dashboard/ManageLoans";
import ManageWireTransfers from "../pages/Dashboard/ManageWireTransfers";
import ManageInterbankTransfers from "../pages/Dashboard/ManageInterbankTransfers";
import ManageOtherTransfers from "../pages/Dashboard/ManageOtherTransfers";

const userRoutes = [
  { path: "/dashboard", component: Dashboard },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "/profile", component: UserProfile },
  { path: "/beneficiaries", component: Beneficiaries },
  { path: "/wire-transfer", component: WireTransfer },
  { path: "/interbank-transfer", component: InterbankTransfer },
  { path: "/paypal", component: PayPalTransfer },
  { path: "/skrill", component: SkrillTransfer },
  { path: "/google-pay", component: GPay },
  { path: "/transfer-wise", component: Wise },
  { path: "/payoneer", component: Payoneer },
  { path: "/manage-loan", component: LoanAdmin },
  { path: "/loan-application", component: LoanApply },
  { path: "/loans", component: LoanHistory },
  { path: "/manage-fdr", component: FDRAdmin },
  { path: "/fdr-application", component: FDRApply },
  { path: "/fdr", component: FDRHistory },
  { path: "/transactions", component: TransactionHistory },
  { path: "/manage-users", component: ManageUsers },
  { path: "/manage-fdradmin", component: ManageFDR },
  { path: "/manage-loanadmin", component: ManageLoans },
  { path: "/manage-wiretransfers", component: ManageWireTransfers },
  { path: "/manage-interbanktransfers", component: ManageInterbankTransfers },
  { path: "/manage-othertransfers", component: ManageOtherTransfers },
]

const authRoutes = [

  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/email/reset/:code", component: ResetPwd },
  { path: "/register", component: Register },
  { path: "/email/verify/:code", component: VerifyingEmail },

]

export { userRoutes, authRoutes }
